import { ThemeApp } from 'themes/types/themeApp/theme.types';

const scrollContainer: ThemeApp['appComponents']['scrollContainer'] = {
  padding: '0.1rem 4rem 0.1rem 0.1rem'
};

export default scrollContainer;
